import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth12postPostScreenTruthRequirementsResponseSchema = jsonObject
export type tcpscreentruth12postPostScreenTruthRequirementsResponse = z.infer<typeof tcpscreentruth12postPostScreenTruthRequirementsResponseSchema>
